import { defaultThemeV2Mapper } from './DefaultThemeV2Mapper';
import { stabilizeGeneratedThemeV2Theme } from '../projection/stabilizeGeneratedThemeV2Theme';
import type { ThemeV2 } from '../types/themesV2.types';

/**
 * Save-time normalization for image-generated project themes.
 *
 * Templates were projected ONCE when the draft was created
 * (createThemeV2DraftFromProjection → applyToFlowDocument). Later token edits
 * reach templates through applyThemeDeltaToFlowDocument in the editor, so a
 * save must NOT re-run the forceful projection: doing so wiped authored
 * template edits (e.g. stepper thickness) and, via cascade-mode
 * applyToBasicScreen, authored chrome colors (page-indicator track color).
 */
export function remapGeneratedThemeForSave(theme: ThemeV2): ThemeV2 {
  const stabilized = stabilizeGeneratedThemeV2Theme(theme).theme;
  const basicScreen = defaultThemeV2Mapper.applyToBasicScreen(stabilized, { mode: 'seed' });
  return { ...stabilized, ...basicScreen, flowDocument: theme.flowDocument };
}
